var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node',{attrs:{"show":false},on:{"insertNode":type => _vm.$emit('insertNode', type)}})
}
var staticRenderFns = []

export { render, staticRenderFns }